// APP REDUCER 
export const GLOBAL_LOADING = "app/global/loading";
export const GLOBAL_MESSAGE = "app/global/message";
export const SET_DIALOG = "app/set/dialog";
export const SET_LOGINSTATUS = "app/set/loginStatus";
export const SET_USERPROFILE = "app/set/user/profile";
export const SET_CURRENTPARTNER = "app/set/current/partner";
export const SET_CURRENTCUSTOMER = "app/set/current/customer";

// ORDER REDUCER
export const SET_SEARCHTYPE = "order/set/searchType";
export const SET_SEARCHPARAMS = "order/set/searchParams";
export const SET_SEARCHFILTERS = "order/set/searchFilters";
export const SET_APPLIEDSEARCHFILTERS = "order/set/applied/searchFilters";
export const SET_SEARCHCURRENCY = "order/set/searchCurrency";
export const SET_SEARCHRESSTATUS = "order/set/searchStatus";
export const SET_SEARCHRESROWSNUMBER = "order/set/searchRowsNumber";
export const SET_SEARCHRESTOKEN = "order/set/searchToken";
export const SET_SEARCHRESCURRENTPAGE = "order/set/searchCurrentPage";
export const SET_SEARCHRESLIMIT = "order/set/searchResultLimit";
export const SET_SEARCHLOCATION = "order/set/searchLocation";
export const SET_SEARCHRESOBJECT = "order/set/searchResultObject";
export const SET_EXCHANGERATES = "order/set/exchangeRates";

// RESERVATION REDUCER
export const SET_RESERVATION = "reservation/set/selected";
export const SET_RESERVATIONSROWS = "reservation/set/rows";

// AGENCY REDUCER
export const SET_AGENCY = "agency/set/selected";
export const SET_AGENCIESROWS = "agency/set/rows";

// USER REDUCER
export const SET_USER = "user/set/selected";
export const SET_USERSROWS = "user/set/rows";

// CUSTOMER REDUCER
export const SET_CUSTOMER = "customer/set/selected";
export const SET_CUSTOMERSROWS = "customer/set/rows";

// ROUTE REDUCER
export const SET_ROUTE = "route/set/selected";
export const SET_ROUTESROWS = "route/set/rows";


